<mat-card id="cadastro">
    <mat-card-header>
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="300px">
          <h3>INCLUSÃO DO EDITAL</h3>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      <p></p>

      <form [formGroup]="form"   class="formulario">

        <div fxLayout.align="center center" fxLayout.xs="column" fxLayoutGap="20px">

          <div class="form_linha" fxLayout.xs="column">
            <mat-form-field class="numero  campo_flex tamanho_100">
               <mat-label> Numero :</mat-label>
               <input matInput formControlName="numero" mask="00.000/00" >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="processo campo_flex tamanho_50">
              <mat-label>Processo:</mat-label>
              <input matInput formControlName="processo"  >
            </mat-form-field>

            <mat-form-field class="sei campo_flex tamanho_50">
              <mat-label>SEI:</mat-label>
              <input matInput formControlName="sei"  >
            </mat-form-field>

          </div>



          <div class="form_linha" fxLayout.xs="column">


            <mat-form-field class="data campo_flex tamanho_50">
              <mat-label>Data:</mat-label>
              <input matInput formControlName="data" mask="00/00/0000" >
            </mat-form-field>

            <mat-form-field class="horario campo_flex tamanho_50">
              <mat-label>Horario:</mat-label>
              <input matInput formControlName="horario" mask="00:00"  >
            </mat-form-field>



          </div>
          <div class="form_linha" fxLayout.xs="column">




            <!--
            <mat-form-field class="modalidade campo_flex tamanho_50">
              <mat-label>Modalidade</mat-label>
              <input matInput formControlName="modalidade" readonly >
            </mat-form-field>
             -->
            <mat-form-field class="modalidade campo_flex tamanho_50">
              <mat-label>Modalidade:</mat-label>
              <mat-select name="modalidade" formControlName="modalidade">
                <mat-optgroup label="modalidade">
                  <mat-option value="">Escolha Modalidade</mat-option>
                  <mat-option value="1">Pregão Presencial</mat-option>
                  <mat-option value="2">Convite</mat-option>
                  <mat-option value="3">Tomada de preço</mat-option>
                  <mat-option value="4">Concorrência pública</mat-option>
                  <mat-option value="5">Concorrência Internacional</mat-option>
                  <mat-option value="6">Concurso</mat-option>
                  <mat-option value="7">Pregão Eletrônico</mat-option>
                  <mat-option value="8">Pregão Internacional</mat-option>
                  <mat-option value="9">Cotação Eletrônica</mat-option>
                  <mat-option value="10">Dispensa 24 IV</mat-option>
                  <mat-option value="11">Dispensa 24 V</mat-option>
                  <mat-option value="12">Dispensa 24 VII</mat-option>
                  <mat-option value="13">	Dispensa 24 VIII</mat-option>
                  <mat-option value="14">Dispensa 24 XI</mat-option>
                  <mat-option value="15">Inexigibilidade 25 I</mat-option>
                  <mat-option value="16">Inexigibilidade 25 II</mat-option>
                  <mat-option value="17">Inexigibilidade 25 III</mat-option>
                  <mat-option value="18">Regime Diferenciado de Contratações - RDC</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>


            <!--
            <mat-form-field class="agrupamento campo_flex tamanho_50">
              <mat-label>Agrupamento</mat-label>
              <input matInput formControlName="agrupamento" readonly >
            </mat-form-field> -->

            
            <mat-form-field class="agrupamento campo_flex tamanho_50">
              <mat-label>Agrupamento:</mat-label>
              <mat-select name="agrupamento" formControlName="agrupamento">
                <mat-optgroup label="agrupamento">
                  <mat-option value="">Escolha Agrupamento</mat-option>
                  <mat-option value="1">Medicamentos</mat-option>
                  <mat-option value="2">Mat.Hospitalar</mat-option>
                  <mat-option value="3">Mat.Não Hospitalar</mat-option>
                  <mat-option value="4">Mat.Permanente</mat-option>
                  <mat-option value="5">Serviços</mat-option>
                 </mat-optgroup>
              </mat-select>
            </mat-form-field>
            
          </div>



          <div class="form_linha" fxLayout.xs="column">



            <mat-form-field class="titulo campo_flex tamanho_50">
              <mat-label>Titulo:</mat-label>
              <input matInput formControlName="titulo" >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">
            <mat-form-field class="descricao campo_flex tamanho_100">
              <mat-label>Descricao:</mat-label>
              <input matInput formControlName="descricao"  >
            </mat-form-field>
          </div>

          <div class="form_linha" fxLayout.xs="column">

            <!--<mat-form-field class="suspensa  campo_flex tamanho_25">
              <mat-label>Suspensa:</mat-label>
              <input matInput formControlName="suspensa" >
            </mat-form-field>-->

            <mat-form-field class="suspensa campo_flex tamanho_25">
              <mat-label>Suspensa:</mat-label>
              <mat-select name="suspensa" formControlName="suspensa">
                <mat-optgroup label="suspensa">
                  <mat-option value="">Escolha Suspensa S/N</mat-option>
                  <mat-option value="S">SIM</mat-option>
                  <mat-option value="N">NÃO</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>

            <!--<mat-form-field class="noar campo_flex tamanho_25">
                <mat-label>No Ar:</mat-label>
                <input matInput formControlName="noar" >
            </mat-form-field> -->           

            <mat-form-field class="noar campo_flex tamanho_25">
              <mat-label>No Ar:</mat-label>
              <mat-select name="noar" formControlName="noar">
                <mat-optgroup label="noar">
                  <mat-option value="">Escolha No Ar S/N</mat-option>
                  <mat-option value="S">SIM</mat-option>
                  <mat-option value="N">NÃO</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </div>



          <div class="form_linha" fxLayout.xs="column">
            <hr>
          </div>




          <!--
          <section class="campo_flex tamanho_100 flex_wrap">
            <div class="campo_flex tamanho_25"><font color="#FF0000" size="4" >- E D I T A L </font></div>

          <div class="campo_flex tamanho_50" >

            <a href="{{caminhoArquivosUpload}}{{m_filename1}}" target="_blank">{{m_filename1}}</a>
            <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('1',caminhoArquivosUpload,m_filename1)"><mat-icon>upload</mat-icon></button>

          </div>


          </section>
         -->
        

          


          <div fxLayoutAlign="center center" class="form_linha botoes">

            <button type="button" mat-raised-button name="retorna" color="warn" (click)="retorna()" >
              Retorna
            </button>

            <button type="button" mat-raised-button name="solicita" color="primary" (click)="enviarAlteracao()" >
              Confirmar Gravação
            </button>

          </div>



        </div>

      </form>

    </mat-card-content>

  </mat-card>
